import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { appVerSelector, environmentSelector, getCorrelationId, omnichannelThemeNameSelector, sourceAppSelector } from '../../../app/selectors/contactUsSelector';
import { FreelanceRequest } from '../../models/requestModels';
import { RequestStatus } from '../../presentationalComponents/RequestDetails/RequestStatus';
import { statusStepsSelector } from '../../reduxUpdater/selectors/requestSelector';
import { getRequestSectionStyles } from '../../styles/requestDetailsStyles';
import { Environment } from '../../../../models/constants/constants';
import { isGetRequestPendingSelector } from '../../reduxUpdater/selectors/requestDetailsSelectors';

interface IRequestProps {
  request: FreelanceRequest;
}

const mapStateToProps = (state: IAppState, ownProps: IRequestProps) => {
  const request = ownProps.request;
  return {
    request: request,
    requestSteps: statusStepsSelector(state, ownProps),
    isOrgId: state.ContactState.ModalitySectionState.isOrgId,
    omnichannelThemeName: omnichannelThemeNameSelector(state),
    isClientApp: state.GlobalState.environment === Environment.nonAgavePane,
    openInAppOmnichannelChatInBrowser: state.ContactState.ModalitySectionState.openInAppOmnichannelChatInBrowser,
    market: state.GlobalState.market,
    environment: environmentSelector(state),
    sourceApp: sourceAppSelector(state),
    appVer: appVerSelector(state),
    isGetRequestPending: isGetRequestPendingSelector(state),
    correlationId: getCorrelationId(state)
  };
};

export const RequestStatusContainer = connect(
  mapStateToProps
)(styled(RequestStatus, getRequestSectionStyles));
